import { storyblokEditable } from "gatsby-source-storyblok"

import { Color } from "../../../../../constants/V2/color"
import PlansCalculatorRecommendedCard, {
  RecommendedPlanConfigs,
} from "../../../../V2/Cards/Plans/RecommendedSlider"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokPlansCalculatorRecommendedCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.PlansCalculatorRecommendedCard>) => {
  let sliderMin = 0
  let sliderMax = 300000

  blok.plans.forEach((plan) => {
    const minRange = plan.minSliderRange ?? 0
    const maxRange = plan.maxSliderRange ?? 300000
    sliderMin = Math.min(sliderMin, minRange)
    sliderMax = Math.max(sliderMax, maxRange)
  })

  const recommendedPlanConfigs: RecommendedPlanConfigs[] = blok.plans
    .filter((plan) => plan.planConfig?.content)
    .map((plan: Storyblok.RecommendedPlanConfig) => ({
      planConfig: plan.planConfig!.content,
      ctaText: plan.ctaText ?? "Learn more",
      ctaLink: storyblokLinkToYocoLink(plan.ctaLink),
      ctaColor: plan.ctaColor,
      testimonialTitle: plan.testimonialTitle,
      testimonialQuote: plan.testimonialQuote,
      testimonialImage: plan.testimonialImage,
      testimonialName: plan.testimonialName,
      testimonialBusiness: plan.testimonialBusiness,
      minSliderRange: Number(plan.minSliderRange ?? 0), //TODO: investigate why this needs to be cast to a number
      maxSliderRange: Number(plan.maxSliderRange ?? sliderMax), //TODO: investigate why this needs to be cast to a number
      tracking: plan.trackingEvent && {
        event: plan.trackingEvent[0]?.event,
        eventKey: plan.trackingEvent[0]?.eventKey,
        eventValue: plan.trackingEvent[0]?.selectedPlan,
      },
    }))

  return (
    <PlansCalculatorRecommendedCard
      mobileGridOrder={mobileGridOrder}
      sliderTitle={blok.title}
      sliderDescription={blok.description}
      sliderMinRange={sliderMin}
      sliderMaxRange={sliderMax}
      sliderInitialValue={blok.sliderInitialValue}
      sliderBackgroundColor={blok.backgroundColor ?? Color.White}
      recommendedPlanConfigs={recommendedPlanConfigs}
      // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokPlansCalculatorRecommendedCard
